import React from 'react';
import { useAuth } from './../auth/AuthContext';
import Chatbot from './../chatbot/chatbot'
import Keyboard from './../chatbot/parts/keyboard'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';


function DeskTopComponent() {

  const { user, subscriptions } = useAuth();
  const isPremium = subscriptions?.chatbotPremium;
  const isStandard = subscriptions?.chatbotStandard;
  const isFreeMember = !isPremium && !isStandard;

  return (
    <>
        <Chatbot />
    </>
  )
}

export default DeskTopComponent;